import React from "react";
import { useLocation } from "react-router-dom";
import ResetPasswordForm from "../../organisms/Auth/ResetPasswordForm";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const ResetPasswordScreen = () => {
  const query = useQuery();
  const email = query.get("email") || "";
  const token = query.get("token") || "";

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh" }}>
      <ResetPasswordForm email={email} token={token} />
    </div>
  );
};

export default ResetPasswordScreen; 